import { del, get, patch, post, put } from "./HttpClient";

export default {
  get,
  post,
  put,
  patch,
  delete: del,
};
